import { AppConstant, KeyConstant, SystemConstant } from "const";
import { getInteractor, getSemaphore } from "services/local.service";
import { StorageUtil, toSnake, uuid } from "utils";
import store, { SystemActions } from "redux-store";

export const sendOneMessageSenderKeyDistributionMessage = async (
  prefixKey,
  group,
  message,
  encryptTypeProtocol,
  indexSend,
) => {
  const semaphore = getSemaphore(prefixKey);
  const [_value, release] = await semaphore.acquire();
  try {
    message = toSnake(message);
    group = toSnake(group);
    const { sender_id, sender_device_id } = message || {};
    const groupId = group?.id || uuid();
    const accountId = StorageUtil.getItem(KeyConstant.KEY_ACCOUNT_ID, prefixKey);
    const deviceId = StorageUtil.getItem(KeyConstant.KEY_DEVICE_ID, prefixKey);
    const senderKeyMessage = await getInteractor(prefixKey).LocalCryptoService.generateDistributionKey(
      accountId,
      deviceId,
      groupId,
      encryptTypeProtocol,
    );
    const contentEncryption = await getInteractor(prefixKey).LocalCryptoService.encryptE2EMessage(
      sender_id,
      sender_device_id,
      groupId,
      senderKeyMessage,
      encryptTypeProtocol,
      indexSend,
    );
    if (contentEncryption?.cipherText) {
      const sessionEntity = await getInteractor(prefixKey).LocalCryptoService.getSessionEntity(
        sender_id,
        sender_device_id,
        groupId,
        encryptTypeProtocol,
      );
      const id = uuid();
      const jsonOption = {
        encrypt_version: encryptTypeProtocol,
        original_send_type: SystemConstant.SEND_TYPE.senderKey,
        target_decrypt_send_type: SystemConstant.SEND_TYPE.senderKey,
        disappearing_f: false,
      };
      jsonOption.encryption_f = 1;
      jsonOption.index_send_number = contentEncryption.indexSendNumber;
      jsonOption.prev_index_number = sessionEntity.prev_index;
      jsonOption.encrypt_version = encryptTypeProtocol;
      const sendOneDistribution = {
        messageId: id,
        sendToDeviceId: sender_device_id,
        sendToAccountId: sender_id,
        content: contentEncryption?.cipherText,
        options: JSON.stringify(jsonOption),
        status: SystemConstant.MESSAGE_STATUS.send,
        sendType: SystemConstant.SEND_TYPE.senderKey,
        mentions: null,
        encryption_type: SystemConstant.ENCRYPTION_TYPE.NORMAL_ENCRYPTION,
      };
      const newMessage = {
        groupId: group.id,
        sourceId: uuid(),
        groupType: group.group_type,
        sendType: SystemConstant.SEND_TYPE.senderKey,
        created: Date.now(),
        messages: [sendOneDistribution],
        branchId: group.branch_id,
        parentId: null,
        threadId: null,
      };
      // Cập nhật prev_index cho session
      let updateValues = {
        prev_index: jsonOption.index_send_number,
      };
      await getInteractor(prefixKey).LocalCryptoService.updateSession(
        updateValues,
        sender_id,
        sender_device_id,
        group.id,
        encryptTypeProtocol,
      );
      await getInteractor(prefixKey).LocalApiCallService.save([
        {
          id: uuid(),
          task: `${AppConstant.API_CALL_TASK.message}`,
          original_uid: newMessage.sourceId,
          query: "",
          content: JSON.stringify({ data: newMessage }),
          original_content: JSON.stringify({ data: newMessage }),
          created: new Date().getTime(),
          retry: 0,
          branch_id: newMessage.branchId,
          group_id: newMessage.groupId,
        },
      ]);
      store.dispatch(SystemActions.executeQueue());
    }
  } finally {
    release();
  }
};
